import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="social-media">
          <h3>{t('footer.followMe')}</h3>
          <div className="social-icons">
            <a href="https://www.instagram.com/ta2gbo" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            <a href="https://www.youtube.com/@TA2GBO" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
            <a href="https://www.qrz.com/db/TA2GBO" target="_blank" rel="noopener noreferrer" aria-label="QRZ.com"><i className="fas fa-broadcast-tower"></i></a>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; {currentYear} TA2GBO. {t('footer.rightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;